import { createErrorType } from '@atlassian/mpac-utils';

/**
 * Takes an fetch error object and tries best to parse it
 * into a status code and a response
 */

export async function parseError(error) {
  var _error$response;
  let response;
  if (error.response) {
    try {
      response = await error.response.json();
    } catch (_unused) {
      try {
        response = await error.response.text();
      } catch (_unused2) {
        console.error('parseError: failed to parse response', error);
      }
    }
  }
  return {
    status: (_error$response = error.response) === null || _error$response === void 0 ? void 0 : _error$response.status,
    response
  };
}
export function makeAPIError(_ref) {
  let {
    name,
    code,
    response
  } = _ref;
  const APIError = createErrorType(name);
  return new APIError({
    code,
    message: "".concat(name, " error"),
    meta: {
      response
    }
  });
}